import { SearchCriteria } from 'src/app/core/interfaces/search-criteria.interface';
import { CollectionFinderItemDTO } from 'src/app/core/interfaces/collection.interface';
import { FIELD_PRIORITY_WEIGHT, SEARCH_FIELD, SearchPriorityConfig } from 'src/app/core/interfaces/search-priority-config';

export class CollectionSubtitleCriteria implements SearchCriteria {
  getMatchScore(_collection: CollectionFinderItemDTO, _query: string): number {

    const subTitle = _collection.subtitle?.toLowerCase() ?? '';
    
    if(subTitle === _query) {
      return 5;
    }
    if(subTitle?.startsWith(_query)) {
      return 3;
    }
    if(subTitle?.includes(_query)) {
      return 1;
    }
    return  0;
  }

  getRelevanceFieldWeightAndMatchScore(_collection: CollectionFinderItemDTO, _query: string): SearchPriorityConfig {
      return {
        relevanceField: SEARCH_FIELD.SUBTITLE,
        fieldPriorityWeight: FIELD_PRIORITY_WEIGHT.SUBTITLE,
        matchScore: this.getMatchScore(_collection, _query)
      }
    }
}
